import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-resume_message",
  "use": "icon-resume_message-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-resume_message\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h30v30H0z\" /><path d=\"M8.069 23.75 2.5 28.125V5c0-.69.56-1.25 1.25-1.25h22.5c.69 0 1.25.56 1.25 1.25v17.5c0 .69-.56 1.25-1.25 1.25H8.069Zm-.865-2.5H25v-15H5v16.731l2.204-1.731Zm6.546-8.75h2.5V15h-2.5v-2.5Zm-5 0h2.5V15h-2.5v-2.5Zm10 0h2.5V15h-2.5v-2.5Z\" fill=\"#BFBFBF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol